AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Url");

AoPS.Alcumus.Url = (function () {
	// Dependencies
	var UrlTable = AoPS.UrlTable;

	return new UrlTable.Table({
		data: {
			// code: Backbone Router URL pattern
			index: "",
			problem: "problem",
			report_redirect: "report",
			report: "report/:user",
			report_subject: "report/:user/subject/:subject",
			report_subject_topic: "report/:user/subject/:subject/:topic",
			report_class: "report/:user/class/:class",
			report_class_topic: "report/:user/class/:class/:topic",
			report_trial: "report/:user/trial/:trial",
			profile_redirect: "profile",
			profile: "profile/:user",
			hall_of_fame: "hall_of_fame",
			hall_of_fame_section: "hall_of_fame/:section",
			help: "help",
			help_section: "help/:section",
			settings: "settings",
			reset: "reset",
			user_problem: "trial/problem/:problem",
			set_focus: "set_focus/:parentid/:parenttype/:topicid",
			welcome: "welcome",
			admin: "admin/main",
			admin_problem_none: "admin/problem",
			admin_problem: "admin/problem/:problem",
			admin_parser: "admin/parser",
			error: "error",
		},
		// Root URL to Alcumus, which all href's have prepended.
		root_url: "/alcumus/",
		// URL to Alcumus images
		image_path: "/alcumus/images/",
	});
})();
